import React, { FC } from "react";
import { TextField, Typography } from "@mui/material";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { Image, Transformation } from "cloudinary-react";
import { paintImages, paintPrime, paints } from "./defaults";
import Video from "../Video";
import { styled } from "@mui/material/styles";
import { RowLayout } from "../../util/accordianStyles";
import usePaintSelector from "./usePaintSelector";
import PleaseNote from "../PleaseNote";

const StyledRowLayoutTopDivider = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  borderTop: `2px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 2),
}));

const PaintPrimeAccordian: FC = () => {
  const {
    handleChange,
    handleClickColor,
    handleClick,
    customPaintColor,
    material,
    customPaintOrStain,
    paintAndPrime,
    paintColor,
    btnChoice,
  } = usePaintSelector();

  return (
    <ReusableAccordian
      accordionName="paintPrime"
      heading={`${material.includes("Clad") ? "Interior" : ""} Paint/Prime`}
      secondaryHeading="Select paint and prime option"
      colOrRow="col"
    >
      <PleaseNote
        notes={[
          "A shade variation in color is expected in production line.",
          customPaintOrStain &&
            "For custom paint please provide sample to AGM for proper pricing.",
        ]}
      />
      <RowLayout>
        {paintPrime.map((state) => (
          <div
            key={state.id}
            onClick={() => handleClick(state.label, state.type)}
          >
            <Choices
              label={state.label}
              variant={state.label === btnChoice ? "filled" : "outlined"}
              checkMark={state.label === btnChoice}
            />
          </div>
        ))}
      </RowLayout>
      {paintAndPrime && (
        <StyledRowLayoutTopDivider>
          {paints.map((state) => (
            <div key={state.id} onClick={() => handleClickColor(state.label)}>
              <Choices
                label={state.label}
                variant={state.label === paintColor ? "filled" : "outlined"}
                checkMark={state.label === paintColor}
              />
            </div>
          ))}
        </StyledRowLayoutTopDivider>
      )}

      {customPaintOrStain ? (
        <TextField
          error={!customPaintColor ? true : false}
          helperText={
            !customPaintColor ? "Please Enter a Custom Paint Color" : ""
          }
          variant="outlined"
          margin="dense"
          size="small"
          onChange={handleChange}
          value={customPaintColor}
        />
      ) : (
        paintAndPrime &&
        paintColor &&
        paintImages
          .filter((image) => image.label === paintColor)
          .map((imageShown) => (
            <RowLayout key={imageShown.img}>
              <Image
                cloudName="ag-millworks"
                secure="true"
                publicId={imageShown.img}
              >
                <Transformation width="150" height="150" crop="scale" />
              </Image>
            </RowLayout>
          ))
      )}

      <Video src="https://youtu.be/fHxhDt6DbMM" />
    </ReusableAccordian>
  );
};

export default PaintPrimeAccordian;
